import { Factory } from 'rosie';

const teamId = 'example-team-id';

Factory.define('TeamEditor').attr('name', 'TEAM_EDITOR');

Factory.define('TeamEditorWithDefaults')
  .extend('TeamEditor')
  .attr('teamId', teamId);
